const FEDERAL_PRICE = '48.90';

const STATE_PRICE = '42.90';

const FORM_8843_PRICE = '14.90';

export { FEDERAL_PRICE, STATE_PRICE, FORM_8843_PRICE };
